import React from "react";
import {
  Briefcase, FileSignature, Clock, Users, Layers, HardHat, UserCog, Wrench,
  ConciergeBell, Hotel, Utensils, SprayCan, Car, Shield, ClipboardList, Calculator,
  Network, RefreshCw, Award, UserCheck, Handshake, MapPin, ListChecks, Building2,
  GraduationCap, Truck, Landmark, Cpu, Megaphone, Headphones, Home, Wheat, Wrench as WrenchAlt,
} from "lucide-react";

const MAP = {
  briefcase: Briefcase, "file-signature": FileSignature, clock: Clock, users: Users,
  layers: Layers, "hard-hat": HardHat, "user-tie": UserCog, wrench: Wrench,
  "concierge-bell": ConciergeBell, hotel: Hotel, utensils: Utensils, "spray-can": SprayCan,
  car: Car, shield: Shield, "clipboard-list": ClipboardList, calculator: Calculator,
  network: Network, "refresh-cw": RefreshCw, award: Award, "user-check": UserCheck,
  handshake: Handshake, "map-pin": MapPin, "list-checks": ListChecks, building: Building2,
  graduation: GraduationCap, truck: Truck, landmark: Landmark, cpu: Cpu,
  megaphone: Megaphone, headphones: Headphones, home: Home, wheat: Wheat,
};

export default function Icon({ name, ...props }) {
  const Cmp = MAP[name] || Briefcase;
  return <Cmp {...props} />;
}
